module.exports = __webpack_public_path__ + "static/media/rehau_70.bff13305.png";